import React from "react";

import GridContainer from "../../mui-components/Grid/GridContainer";
import ItemGrid from "../../mui-components/Grid/GridItem";
import RegularCard from "../../mui-components/Card/RegularCard";
import FiSwapSuggestionsTable from "../../containers/domain/fi-swap-suggestion/FiSwapSuggestionsTable";

const FiSwapSuggestionsListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard
        title="Lista de sugestões de troca de renda fixa"
        content={<FiSwapSuggestionsTable />}
      />
    </ItemGrid>
  </GridContainer>
);

export default FiSwapSuggestionsListingView;
